export default {
    namespaced: true,
    state: {
      deliveryAddress: {}
    },
    getters: {
        deliveryAddress: state => state.deliveryAddress
    },
    actions: {
      resetCurrent: (context) => {
        context.commit('resetCurrent');
      },
      setDeliveryAddress: (context, address) => {
        context.commit("setDeliveryAddress", address);
      }            
    },
    mutations: {
      resetCurrent: (state) => {
        state.deliveryAddress = {};
      },
      setDeliveryAddress: (state, deliveryAddress) => {
        state.deliveryAddress = { ...deliveryAddress }; //make a "deep" copy
      }      
    }
  }
  